import { useEffect } from "react";
import { GetBanners, GetHomeData } from "../../store/Actions/action";
import { useReduxStore } from "../../hooks/useReduxStore";
import { updateItem } from "../../store/Reducers/itemReducer";
import { useNavigate } from "react-router-dom";
import { updateHome } from "../../store/Reducers/homeReducer";
import { scrollToTop } from "../../helper/helper";

const useLandingNew = () => {
  const { getState, dispatch } = useReduxStore();
  const navigate = useNavigate();
  const {
    categories,
    selectedCategory,
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
  } = getState("Home");

  useEffect(() => {
    dispatch(GetBanners());
    dispatch(GetHomeData());
    dispatch(updateItem({ itemDetail: {} }));
  }, [dispatch]);

  const onCategorySelect = (categoryName) => {
    if (!categoryName) return;

    const normalizedSelectedName = categoryName.toLowerCase().replace(/[^a-z]/g, "");
    const isExclusive =
      normalizedSelectedName.includes("exclusive") ||
      categoryName.toLowerCase().includes("exclusive");

    // 1. Dedicated handling for Exclusive Content
    if (isExclusive) {
      // Check if a category truly named "Exclusive Content" or "Exclusive" exists in backend categories
      const exclusiveCat = categories?.find((cat) =>
        cat?.name?.toLowerCase().replace(/[^a-z]/g, "").includes("exclusive")
      );

      if (exclusiveCat) {
        dispatch(updateHome({ selectedCategory: exclusiveCat }));
      } else if (!selectedCategory && categories && categories.length > 0) {
        // Fallback to first available category so the API has a valid base category
        dispatch(updateHome({ selectedCategory: categories[0] }));
      }

      scrollToTop();
      navigate("/ProductCollection?access_type=exclusive", {
        state: { accessType: "exclusive" },
      });
      return;
    }

    // 2. Standard content categories (AudioBooks, EBooks, Movies, Songs/Music)
    const matchedCategory = categories?.find((cat) => {
      const normalizedCatName = cat?.name?.toLowerCase().replace(/[^a-z]/g, "");
      if (normalizedSelectedName === "audiobooks" && (normalizedCatName === "audiobooks" || normalizedCatName === "audiobook")) return true;
      if (normalizedSelectedName === "ebooks" && (normalizedCatName === "ebooks" || normalizedCatName === "ebook")) return true;
      if (normalizedSelectedName === "movies" && (normalizedCatName === "movies" || normalizedCatName === "movie")) return true;
      if (normalizedSelectedName === "songs" && (normalizedCatName === "music" || normalizedCatName === "songs" || normalizedCatName === "musics")) return true;
      return normalizedCatName === normalizedSelectedName;
    });

    if (matchedCategory) {
      dispatch(updateHome({ selectedCategory: matchedCategory }));
    }

    scrollToTop();
    navigate("/ProductCollection", { state: {} });
  };

  return {
    categories,
    selectedCategory,
    homeBanners,
    popularLoading,
    trendingLoading,
    categoriesItems,
    popularItems,
    trendingItems,
    onCategorySelect,
  };
};

export default useLandingNew;
